import { Avatar } from '@/components/Avatar/Avatar'
import CheckSvg from '@/icons/check.svg?react'
import { useCommitsState } from '@/state/commits'
import { useGeneratorState } from '@/state/generator'
import { useRepoListState } from '@/state/repoList'
import classNames from 'classnames'
import { formatDistanceToNowStrict } from 'date-fns'
import type { FunctionalComponent } from 'preact'
import { useMemo } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'
import styles from './index.module.scss'

export const RepoCommit:
  & FunctionalComponent<{
    repoId: number
    sha: string
  }>
  & {
    Item: FunctionalComponent
  } = props => {
    const commitItem = useCommitsState(useShallow(s =>
      s.byRepoId[props.repoId]?.list
        .find(item => item.commit.sha === props.sha)
    ))

    const repo = useRepoListState(useShallow(s => s.list.find(item => item.id === props.repoId)))

    const toggleCommit = useGeneratorState(s => s.toggleCommit)

    const selected = useGeneratorState(s => (
      !!s.list.find(item => (
        commitItem && item.repoId === props.repoId && item.sha === commitItem.commit.sha
      ))
    ))

    const dateStr = useMemo(() => {
      const date = commitItem?.commit.commit.author?.date
      return date ? formatDistanceToNowStrict(new Date(date)) : null
    }, [commitItem])

    if (!commitItem || !repo) {
      return null
    }

    return (
      <div class={styles.wrapper}>
        <div
          class={classNames(styles.root, {
            [styles.processed]: commitItem.state.processed,
          })}
          onClick={() => {
            toggleCommit(props.repoId, commitItem.commit.sha)
          }}
        >
          <div class={styles.title}>
            <div
              className={classNames(styles.check, {
                [styles.selected]: selected,
              })}
            >
              <CheckSvg />
            </div>

            {commitItem.commit.author?.avatar_url && (
              <Avatar
                size={16}
                src={commitItem.commit.author.avatar_url}
              />
            )}

            <div class={styles.message}>
              {commitItem.commit.commit.message}
            </div>
          </div>

          <div class={styles.date}>
            {dateStr}
          </div>
        </div>
      </div>
    )
  }

RepoCommit.Item = props => (
  <div class={classNames(styles.wrapper, styles.loader)}>
    <div class={styles.root}>
      <div class={styles.title}>
        {props.children}
      </div>
    </div>
  </div>
)
